import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API_BASE_URL } from "../../constants";
import { enqueueSnackbar } from "notistack";

export const useCaptureOrderMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationKey: ["useCaptureOrderMutation"],
    mutationFn: async (paymentId) => {
      return await fetch(`${API_BASE_URL}/capture-order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ order_id: paymentId }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Order captured: ", data);
        });
    },
    onSuccess: () => {
      client.invalidateQueries("useTrainingsQuery");
      client.invalidateQueries(["useTrainingDetailsQuery"]);
      enqueueSnackbar("Thank you for your purchase!", {
        variant: "success",
      });
    },
  });
};
